/**
 * Enum for feature names used throughout the application.
 * These are typically used for analytics tracking and tutorial identification.
 */
export enum Feature {
  PortfolioAnalysis = 'PortfolioAnalysis',
  MaAnalytics = 'MA_Analytics',
  ValuationsPage = 'ValuationsPage',
  ValuationPageDetails = 'ValuationDetailPage',
  OilAndGasMap = 'OilAndGasMap',
}

export type FeatureType = `${Feature}`;
